/* eslint-disable max-len */
import Show from '@common_show';
import cx from 'classnames';
import Image from 'next/image';

const ProductLabelAmasty = (props) => {
    const {
        amasty_product_labels,
        amasty_sell_product_labels,
    } = props;
    function generateStyle(stringStyle) {
        return stringStyle?.split(';').reduce((acc, curr) => {
            if (!curr) return acc;
            const [key, value] = curr.split(':');
            return { ...acc, [key.trimStart()]: value.trimStart() };
        }, {});
    }

    return (
        <>
            <Show when={amasty_product_labels?.length > 0}>
                {
                    amasty_product_labels?.map((itemLabel, indexLabel) => (
                        <div
                            key={indexLabel}
                            className={cx(
                                'absolute z-[1] item-label',
                                itemLabel?.position === '0' && 'pos-top-left left-0 top-0',
                                itemLabel?.position === '1' && 'pos-top-center left-[50%] top-0 translate-x-[-50%]',
                                itemLabel?.position === '2' && 'pos-top-right right-0 top-0',
                                itemLabel?.position === '3' && 'pos-middle-left left-0 top-[50%] translate-y-[-50%]',
                                itemLabel?.position === '4' && 'pos-middle-center left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] z-30',
                                itemLabel?.position === '5' && 'pos-middle-right right-0 top-[50%] translate-y-[-50%]',
                                itemLabel?.position === '6' && 'pos-bottom-left bottom-0 left-0',
                                itemLabel?.position === '7' && 'pos-bottom-center bottom-0 left-[50%] translate-x-[-50%]',
                                itemLabel?.position === '8' && 'pos-bottom-right bottom-0 right-0',
                                !itemLabel?.image && itemLabel?.label_text && itemLabel?.label_text !== '' && 'py-[3px] px-[7px] text-[12px]',
                                itemLabel.background_color && 'bg-field',
                            )}
                            style={{
                                ...generateStyle(itemLabel?.style),
                            }}
                        >
                            <style jsx>
                                {`
                                .bg-field {
                                    background-color: ${itemLabel?.background_color};
                                }
                                `}
                            </style>
                            {
                                // eslint-disable-next-line no-nested-ternary
                                !itemLabel?.image && itemLabel?.label_text ? (
                                    itemLabel?.label_text
                                ) : itemLabel?.image ? (
                                    <div className="label-image">
                                        <Image
                                            src={itemLabel?.image || ''}
                                            alt={itemLabel?.label_text || ''}
                                            height={itemLabel?.image_size || null}
                                            width={itemLabel?.image_size || null}
                                        />
                                    </div>
                                ) : (
                                    null
                                )
                            }
                        </div>
                    ))
                }
            </Show>

            <Show when={amasty_sell_product_labels?.length > 0}>
                {
                    amasty_sell_product_labels?.map((itemLabel, indexLabel) => (
                        <div
                            key={indexLabel}
                            className={cx(
                                'absolute z-[1] item-label',
                                itemLabel?.position === '0' && 'pos-top-left left-0 top-0',
                                itemLabel?.position === '1' && 'pos-top-center left-[50%] top-0 translate-x-[-50%]',
                                itemLabel?.position === '2' && 'pos-top-right right-0 top-0',
                                itemLabel?.position === '3' && 'pos-middle-left left-0 top-[50%] translate-y-[-50%]',
                                itemLabel?.position === '4' && 'pos-middle-center left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] z-30',
                                itemLabel?.position === '5' && 'pos-middle-right right-0 top-[50%] translate-y-[-50%]',
                                itemLabel?.position === '6' && 'pos-bottom-left bottom-0 left-0',
                                itemLabel?.position === '7' && 'pos-bottom-center bottom-0 left-[50%] translate-x-[-50%]',
                                itemLabel?.position === '8' && 'pos-bottom-right bottom-0 right-0',
                                !itemLabel?.image && itemLabel?.label_text && itemLabel?.label_text !== '' && 'py-[3px] px-[7px] text-[12px]',
                                itemLabel.background_color && 'bg-field',
                            )}
                            style={{
                                ...generateStyle(itemLabel?.style),
                            }}
                        >
                            <style jsx>
                                {`
                                .bg-field {
                                    background-color: ${itemLabel?.background_color};
                                }
                                `}
                            </style>
                            {
                                // eslint-disable-next-line no-nested-ternary
                                !itemLabel?.image && itemLabel?.label_text ? (
                                    itemLabel?.label_text
                                ) : itemLabel?.image ? (
                                    <div className="label-image">
                                        <Image
                                            src={itemLabel?.image || ''}
                                            alt={itemLabel?.label_text || ''}
                                            height={itemLabel?.image_size || '40'}
                                            width={itemLabel?.image_size || '40'}
                                        />
                                    </div>
                                ) : (
                                    null
                                )
                            }
                        </div>
                    ))
                }
            </Show>
        </>
    );
};

export default ProductLabelAmasty;
